<div class="dialog-wrapper">
  <div class="dialog-icon" [class.danger]="dangerous">
    <mat-icon>{{dangerous ? 'warning' : 'info'}}</mat-icon>
  </div>

  <div class="dialog-content">
    <h2 class="dialog-title">{{data.title || 'Confirm Dialog'}}</h2>
    <p class="dialog-message">{{data.message || data.messageBody}}</p>
  </div>

  <div class="dialog-actions">
    <button mat-button class="cancel-btn" (click)="onNoClick('cancel')">
      {{data.cancelText || 'Cancel'}}
    </button>
    <button mat-flat-button [class.danger-btn]="dangerous" [class.primary-btn]="!dangerous"
      (click)="onNoClick('confirm')" cdkFocusInitial>
      {{data.confirmText || 'Confirm'}}
    </button>
  </div>
</div>